import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { RuleEngineService } from "../services/rule-engine.service";
import { DataParserService } from "../services/data-parser.service";

import { Rule, RuleExpression, RuleExpressoins } from "./models/rule-engine";
import { MatDialog } from "@angular/material/dialog";
import { ExpressionBuilderComponent } from "./expression-builder/expression-builder.component";
import { PredicateFilterComponent } from "./predicate-filter/predicate-filter.component";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: "app-rule-config-component",
  templateUrl: "./rule-config-component.component.html",
  styleUrls: ["./rule-config-component.component.scss"],
})
export class RuleConfigComponentComponent {
  
  isPopUp: boolean = false;
  disableBuildExpression: boolean = true;
  isExpressionBuilderPopUp: boolean = false;
  isFirstView: boolean = true;
  opentemplate: boolean = false;
  finalExpression!: string;
  routeGuid:string;
  totalrecords: number;
  cacheList:any[]=[];
  private _ruleEngineService!: RuleEngineService;
  private _popUpSubscription!: Subscription;
  private _rulesSubjectSubscription!: Subscription;
  private _isExpressionBuilderPopUpSubjectSubscription!: Subscription;
  private _finalRuleExpressionSubjectSubscription!: Subscription;
  private rules: Rule[] = [];
  // private ngxUiLoaderService: NgxUiLoaderService
  

  constructor(
    private toastr: ToastrService,
    public dialog: MatDialog,
    ruleEngineService: RuleEngineService,
    public dialogRef: MatDialogRef<RuleConfigComponentComponent>,
    private _dataParserService: DataParserService,
    private ngxUiLoaderService: NgxUiLoaderService,
    @Inject(MAT_DIALOG_DATA) public ruleConfigRequest: any
  ) {
    this._ruleEngineService = ruleEngineService;
  }

  ngOnInit(): void {
    //fetch all the rules if present
    this._rulesSubjectSubscription = this._ruleEngineService
      .getAllRules()
      .subscribe({
        next: (data) => {
          this.rules = data ?? [];
          if (data != null) {
            this.disableBuildExpression = false;
          }
        },
        error: (err) => {
          this.toastr.error("Unable to fetch Rules", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        },
      });
      this._popUpSubscription = this._ruleEngineService.$getPopUpValue.subscribe({
        next: (data) => {this.isPopUp = data;
          if(this.isPopUp){
            this.openPredicateDialog();
          }
        },
        error: (err) => {
          this.toastr.error("Unable to open sub conditions", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        }
      });
    //fetch the final rule expression if present
    this._finalRuleExpressionSubjectSubscription =
      this._ruleEngineService.$getFinalRuleExpression.subscribe({
        next: (data: any) => {
          if (this.isFirstView && this.ruleConfigRequest.isView) {
            this.finalExpression = this.convertTheNumberRuleExpToNamedRuleExp(
              this.ruleConfigRequest.data[0].ruleSatisfaction,
              this.ruleConfigRequest.data[0].rules
            );
          } else {
            this.finalExpression = data;
          }
        },
        error: (err) => {
          this.toastr.error("Unable to fetch Rule Expression", "", {
            timeOut: 4000,
            positionClass: "toast-bottom-right",
          });
        },
      });

    //If the user is viewing the rules which is already created then we will read the old rules and view them
    if (this.ruleConfigRequest.isView) {
      this.viewSavedRules(this.ruleConfigRequest.data);
    }
    //If the user is creating the new route then we would not have any rules in the database so we will no view the saved rules we will set the master rules.
    else {
      this.setMasterRules(this.ruleConfigRequest.data);
      this.prepareJsonFromDefaultRules();
      this.buildFinalExpression();
    }

    //this entire if condition will run only in case of viewing the rule and not while creating the new route
    if (this.ruleConfigRequest.isView) {
      //this will run only if the there are rules and the user is viewing the rules for the first time
      if (this.rules.length > 0 && this.isFirstView) {
        this.finalExpression = this.convertTheNumberRuleExpToNamedRuleExp(
          this.ruleConfigRequest.data[0].ruleSatisfaction,
          this.ruleConfigRequest.data[0].rules
        );
        this.prepareJsonFromFinalExp(
          this.finalExpression
        );
        this.buildFinalExpression();
        this.isFirstView = false;
      }
    }
    this.routeGuid = this.ruleConfigRequest.routeGuid;
    this._ruleEngineService.setAllTheRules(this.rules);
  }

  //#region ng destroy
  ngOnDestroy(): void {
    if (this._popUpSubscription) {
      this._popUpSubscription.unsubscribe();
    }
    if (this._rulesSubjectSubscription) {
      this._rulesSubjectSubscription.unsubscribe();
    }
    if (this._isExpressionBuilderPopUpSubjectSubscription) {
      this._isExpressionBuilderPopUpSubjectSubscription.unsubscribe();
    }
    if (this._finalRuleExpressionSubjectSubscription) {
      this._finalRuleExpressionSubjectSubscription.unsubscribe();
    }
    this._ruleEngineService.setAllTheRules([]);
    this._ruleEngineService.setFinalRuleExpression("");
    this._dataParserService.setJsonDataForMatTree(null);
    this._ruleEngineService.setFileName("");
    this.opentemplate = false;
  }
  //#endregion

  onClickBuildExpression() {
    if (this.ruleConfigRequest.isView) {
      // if (this.rules.length > 0 && this.isNotFirstView) {
      //   this.prepareTheJsonUsingTheFinalExpressionToSendToTheExpressionBuilderComponent(
      //     this.finalExpression
      //   );
      // }
      if (this.rules.length > 0 && this.isFirstView) {
        this.prepareJsonFromFinalExp(
          this.ruleConfigRequest.data[0].ruleSatisfaction
        );
      }
      this.buildFinalExpression();
      // this.isNotFirstView = true;
      this.isFirstView = false;
      this.isExpressionBuilderPopUp = true;
    } 
    else if (!this.ruleConfigRequest.isView) {
      // this.prepareTheJsonToSendToTheExpressionBuilderComponent();
      // this.buildFinalExpression();
      this.isExpressionBuilderPopUp = true;
    }

    if (this.isExpressionBuilderPopUp) {
      const dialogRef = this.dialog.open(ExpressionBuilderComponent, {
        height: "85%",
        width: "90%",
        maxHeight: "18vw !important",
        data: {},
        disableClose: true,
        panelClass: "custom-dialog-container",
        autoFocus: false,
      });
      dialogRef.afterClosed().subscribe((result) => {
        this.isExpressionBuilderPopUp = false; // Reset flag after closing
      });
    }
  }

  setMasterRules(ruleConfigRequest: any) {
    let ruleNumber = 1;
    if (ruleConfigRequest.length > 0) {
      ruleConfigRequest.forEach((rule: any) => {
        if (rule.EntityType + rule.TypeName === "FacilityOrganization") {
          let createdRule :Rule = {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/OrderingProvider/Location[@AccountType='Ordering Facility']/@OrganizationGUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        } else if (rule.EntityType + rule.TypeName === "FacilityAccount") {
          let createdRule :Rule = {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/OrderingProvider/Location[@AccountType='Ordering Facility']/@GUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        } else if (
          rule.EntityType + rule.TypeName ===
          "LaboratoryOrganization"
        ) {
          let createdRule :Rule = {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/ServiceProvider/Location[@AccountType='Laboratory']/@OrganizationGUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        } else if (rule.EntityType + rule.TypeName === "LaboratoryAccount") {
          let createdRule :Rule = {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/ServiceProvider/Location[@AccountType='Laboratory']/@GUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        }
        else if(rule.EntityType + rule.TypeName === "Send OutAccount"){
          let createdRule :Rule = {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/ServiceProvider[@Type='Laboratory']/Location[@AccountType='Send-out Laboratory']/@GUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        }
        else if(rule.EntityType + rule.TypeName === "Send InAccount"){
          let createdRule : Rule = {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/ServiceProvider[@Type='Laboratory']/Location[@AccountType='Send-in Laboratory']/@GUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        }
        else if(rule.EntityType + rule.TypeName === "Send OutOrganization"){
          let createdRule : Rule= {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/ServiceProvider[@Type='Laboratory']/Location[@AccountType='Send-out Laboratory']/@OrganizationGUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        }
        else if(rule.EntityType + rule.TypeName === "Send InOrganization"){
          let createdRule :Rule = {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/ServiceProvider[@Type='Laboratory']/Location[@AccountType='Send-in Laboratory']/@OrganizationGUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        }
        else if(rule.EntityType + rule.TypeName === "EPGAccount"){
          let createdRule :Rule = {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/ReportingProvider[@Type='Pathologist']/Location[@AccountType='Pathologist Account']/@GUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        }
        else if(rule.EntityType + rule.TypeName === "EPGOrganization"){
          let createdRule : Rule= {
            rulenumber: ruleNumber++,
            rulename: rule.EntityType + rule.TypeName,
            value: rule.Guid,
            field:
              "Case/ReportingProvider[@Type='Pathologist']/Location[@AccountType='Pathologist Account']/@OrganizationGUID",
            operator: "IN",
          };
          this.rules.push(createdRule);
        }
      });
    }
  }

  private getAllRulesAsRuleExpresions(): RuleExpression[] {
    const operationMap: { [key: string]: string } = {
      'NOT IN': 'notin',
      'IN': 'in',
      'CONTAINS': 'contains'
    };
    let ruleExpressions: RuleExpression[] = this.rules.map((rule: Rule) => {
      let transformedOperation = operationMap[rule.operator.toLowerCase()] || rule.operator.toLowerCase().split(" ").join("");
      let ruleExpression: RuleExpression = {
        rulenumber: rule.rulenumber,
        field: rule.field,
        operation: transformedOperation,
        delimiter: "|",
        value: rule.value,
        rulename: rule.rulename,
        ruletype: rule.ruletype ?? '',
        param: rule.param ?? ''
      };
      return ruleExpression;
    });
    return ruleExpressions;
  }
  onClickSave() {
    if(this.finalExpression === null || this.finalExpression === ''){
      this.toastr.warning("Please create rule expression", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    }
    else{
      let result = this.getAllRulesAsRuleExpresions();
      let finalNamedRuleExp = this.convertTheNamedRuleExpToNumberRuleExp(this.finalExpression, this.rules)
      let ruleExpressions: RuleExpressoins[] = [
        {
          rules: result,
          ruleSatisfaction: finalNamedRuleExp,
        },
      ];
      this.dialogRef.close(ruleExpressions);
    }
    //Here we are clearing the cache of the route to reflect the latest changes.
    this.getAllTheCache(this.routeGuid);
  }

  getAllTheCache(routeGuid: string) {
    const obj = {
    pageNumber: 1,
    pageSize: 100,
    keysearch: routeGuid
  };

  this.ngxUiLoaderService.start();
  this._ruleEngineService.getCoreCache(obj).subscribe({
    next: (data) => {
      if (data.length > 0) {
        data.forEach((V, index) => {
          let obj = {};
          obj['key'] = V["key"];
          // obj['ischecked'] = false;
          this.totalrecords = V["count"];
          // if (this.pagenumber > 0 && this.paginator != undefined) {
          //   this.paginator.length = this.totalrecords;
          // }
          this.ngxUiLoaderService.stop();
          this.cacheList.push(obj);
        });
        this.clearCache();
      } else {
        this.ngxUiLoaderService.stop();
        // this.toastr.error("Cache data not found", "", {
        //   timeOut: 4000,
        //   positionClass: 'toast-bottom-right'
        // });
        this.cacheList = [];
      }
    },

    error: () => {
      this.ngxUiLoaderService.stop();
      this.toastr.error("Error Occurred", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
      this.cacheList = [];
    }
  });
}
  clearCache(){
    // let filteredData=this.cacheList.filter(V=>V.ischecked==true);
    // let newdata=this.cacheList.filter(V=>V.ischecked!=true);
    let finalString='';
    this.cacheList.forEach(V=>{
      finalString+=V['key']+',';
    });
    this.ngxUiLoaderService.start();
    this._ruleEngineService.getClearCache(finalString.substring(0, finalString.length - 1)).subscribe(data => {
      // if(data["status"]=='Success'){
        // this.cacheList=newdata;
      // this.toastr.success("Re-Populated Successfully", "", {
      //   timeOut: 4000,
      //   positionClass: 'toast-bottom-right'
    //  });
      // }
      // else{
      //   this.toastr.error("Failed to re-populate", "", {
      //     timeOut: 4000,
      //     positionClass: 'toast-bottom-right'
      //  });
      // }
      
    }),error=>{
      this.ngxUiLoaderService.stop();
    //   this.toastr.error("Error Occured", "", {
    //     timeOut: 4000,
    //     positionClass: 'toast-bottom-right'
    //  });
    };
    this.ngxUiLoaderService.stop();
  }
  OnClickClose() {
    if (this.ruleConfigRequest.isView) {
      this.dialogRef.close();
    } else {
      this.onClickSave();
    }
  }

  //#region This method will generate the json required to render the build expression component
  prepareJsonFromDefaultRules() {
    if (this.rules.length > 0) {
      let expressionGroupObj = {};
      let expressionGroupArray = [];
      let expressionArray = [];
      this.rules.forEach((rule: Rule, index: number) => {
        if (index === 0) {
          let expressionGroup = {
            condition: "",
            rule: rule.rulename,
          };
          expressionArray.push(expressionGroup);
        } else {
          let expression = {
            condition: "AND",
            rule: rule.rulename,
          };
          expressionArray.push(expression);
        }
      });
      expressionGroupArray.push({
        expressionArray: expressionArray,
        groupOperator: "",
      });
      expressionGroupObj = {
        expressionGroupArray: expressionGroupArray,
      };
      this._ruleEngineService.holdTheBuildExpressionData = expressionGroupObj;
    }
  }
  //#endregion

  //#region This method prepares the JSON needed for showing the contents of the expression builder when the final rule expression is empty
  prepareTheJsonForEmptyFinalRuleExpression() {
      let expressionGroupObj = {};
      let expressionGroupArray = [];
      let expressionArray = [];
          let expressionGroup = {
            condition: "",
            rule: "",
          };
          expressionArray.push(expressionGroup);
          let expression = {
            condition: "",
            rule: "",
          };
          expressionArray.push(expression);
      expressionGroupArray.push({
        expressionArray: expressionArray,
        groupOperator: "",
      });
      expressionGroupObj = {
        expressionGroupArray: expressionGroupArray,
      };
      this._ruleEngineService.holdTheBuildExpressionData = expressionGroupObj;
    }
    //#endregion
  
  //#region This method will prepare the json needed to render the build expression component by using the final rule expression
  prepareJsonFromFinalExp(
    ruleSatisfaction: string
  ) {
    const regexSingleRule = /^\(\s*[a-zA-Z0-9_]+(?:\s+(?!AND|OR\b)[a-zA-Z0-9_]+)*\s*\)$/i;
    const regexAndOrRule =
      /^\(\s*[a-zA-Z0-9_ ]+(\s+(AND|OR)\s+[a-zA-Z0-9_ ]+)+\s*\)$/i;
    const regexMultipleAndOr = /^\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)\s*(AND|OR)\s*\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)(\s*(AND|OR)\s*\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\))*$/i;
    let formValue;

    if (regexSingleRule.test(ruleSatisfaction.trim())) {
      formValue = this.generateJsonForFormForSingleRule(ruleSatisfaction);
    } else if (regexAndOrRule.test(ruleSatisfaction.trim())) {
      formValue = this.generateJsonForFormForAndOrRule(ruleSatisfaction);
    } else if (regexMultipleAndOr.test(ruleSatisfaction.trim())) {
      formValue = this.generateJsonForFormForMultipleAndOr(ruleSatisfaction);
    }  
    this._ruleEngineService.holdTheBuildExpressionData = formValue;
  }
  

  generateJsonForFormForSingleRule(ruleSatisfaction: string) {
    const rule = ruleSatisfaction.replace(/[()]/g, "").trim();
    let formValue = {
      expressionGroupArray: [
        {
          expressionArray: [{ condition: "", rule: rule }],
          groupOperator: "",
        },
      ],
    };
    return formValue;
  }
  generateJsonForFormForAndOrRule(ruleSatisfaction: string) {
    // Remove outer parentheses and trim spaces
    const innerExpression = ruleSatisfaction.trim().slice(1, -1);
    // Split based on AND or OR while preserving operators
    const tokens = innerExpression.split(/\s+(AND|OR)\s+/i);

    let expressionArray: { condition: string; rule: string }[] = [];
    let currentCondition = "";

    for (const token of tokens) {
      if (token.toUpperCase() === "AND" || token.toUpperCase() === "OR") {
        currentCondition = token.toUpperCase(); // Store the operator
      } else {
        expressionArray.push({ condition: currentCondition, rule: token });
        currentCondition = ""; // Reset after applying
      }
    }

    return {
      expressionGroupArray: [
        {
          expressionArray,
          groupOperator: "",
        },
      ],
    };
  }
  generateJsonForFormForMultipleAndOr(ruleSatisfaction: string) {
    const regexGroup =
      /\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)/gi;
    const regexOperator = /\)\s*(AND|OR)\s*\(/gi;

    // Extract groups and operators
    const groups = ruleSatisfaction.match(regexGroup) || [];
    const operators = [...ruleSatisfaction.matchAll(regexOperator)].map(
      (match) => match[1]
    );

    const expressionGroupArray = groups.map((group, index) => {
      // Use the generateJsonForAndOrRule logic for each group
      const { expressionGroupArray } =
        this.generateJsonForFormForAndOrRule(group);

      // Dynamically assign the groupOperator for each group
      return {
        ...expressionGroupArray[0], // Spread the expression array and groupOperator structure
        groupOperator: index < operators.length ? operators[index] : "", // Assign operator between groups
      };
    });

    return { expressionGroupArray };
  }
//#endregion
  buildFinalExpression() {
    const jsonDataToBuildFinalExpressoin =
      this._ruleEngineService.holdTheBuildExpressionData.expressionGroupArray;
    let finalstr = jsonDataToBuildFinalExpressoin
      .map((group: any, index: any) => {
        let innerExpression = group.expressionArray
          .map(
            (exp: any) =>
              `${exp.condition ? exp.condition + " " : ""}${exp.rule}`
          )
          .join(" ");
        // Wrap the inner expression in parentheses
        return `(${innerExpression.trim()})${
          index < jsonDataToBuildFinalExpressoin.length - 1 &&
          group.groupOperator
            ? ` ${group.groupOperator}`
            : ""
        }`;
      })
      .join(" ");
    this._ruleEngineService.setFinalRuleExpression(finalstr);
  }

  viewSavedRules(rulesData) {
    const operationMap: { [key: string]: string } = {
      'notin': 'NOT IN',
      'in': 'IN',
      'contains': 'CONTAINS'
    };
    rulesData[0].rules.forEach((rule: any) => {
      let transformedOperator = operationMap[rule.operation.toLowerCase()] || rule.operation; // Use the mapping or keep original
        let ruleToAdd :Rule = {
          rulenumber: rule.rulenumber,
          rulename: rule.rulename,
          value: rule.value,
          field: rule.field,
          operator: transformedOperator,
          ruletype: rule.ruletype,
          param: rule.param
        };
        this.rules.push(ruleToAdd);
    });
    this.finalExpression = this.convertTheNumberRuleExpToNamedRuleExp(
      this.ruleConfigRequest.data[0].ruleSatisfaction,
      this.rules
    );
  }

  openPredicateDialog() {
    const dialogRef = this.dialog.open(PredicateFilterComponent, {
      height: "85%",
      width: "90%",
      maxWidth: "18vw !important",
      data: {},
      disableClose: true,
      panelClass: "Predicate-dialog-container",
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.isPopUp = false;
    });
  }

  onTemplateClose() {
    this.opentemplate = false;
  }
  onClickOpenTemplate(event: any) {
    this.opentemplate = true;
  }

  //#region This is responsible for converting the rule expression with rule numbers into rule expression with rule names
  convertTheNumberRuleExpToNamedRuleExp(
    finalNumberRuleExp: string,
    rules: any
  ) {
    let finalExpression;
    const regexSingleRule = /^\([a-zA-Z0-9_]+\)$/i;
    const regexAndOrRule =
      /^\(\s*[a-zA-Z0-9_ ]+(\s+(AND|OR)\s+[a-zA-Z0-9_ ]+)+\s*\)$/i;
    const regexMultipleAndOr =
      /^\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)\s*(AND|OR)\s*\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)(\s*(AND|OR)\s*\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\))*$/i;
    if (regexSingleRule.test(finalNumberRuleExp.trim())) {
      finalExpression = this.generateFinalRuleExpForSingleRule(
        finalNumberRuleExp,
        rules
      );
    } else if (regexAndOrRule.test(finalNumberRuleExp.trim())) {
      finalExpression = this.generateFinalRuleExpForAndOrRule(
        finalNumberRuleExp,
        rules
      );
    } else if (regexMultipleAndOr.test(finalNumberRuleExp.trim())) {
      finalExpression = this.generateFinalRuleExpForMultipleAndOr(
        finalNumberRuleExp,
        rules
      );
    }
    return finalExpression;
  }

  generateFinalRuleExpForSingleRule(finalNumberRuleExp: string, rules: any) {
    const ruleNumber = finalNumberRuleExp.replace(/[()]/g, "").trim();
    let finalExpression;
    rules.map((rule: Rule) => {
      if (rule.rulenumber.toString() === ruleNumber) {
        finalExpression = rule.rulename;
      }
    });
    return `(${finalExpression.trim()})`;
  }
  generateFinalRuleExpForAndOrRule(finalNumberRuleExp: string, rules: any) {
    let finalExpression = "";
    // Remove outer parentheses and trim spaces
    const innerExpression = finalNumberRuleExp.trim().slice(1, -1);
    // Split based on AND or OR while preserving operators
    const tokens = innerExpression.split(/\s+(AND|OR)\s+/i);

    tokens.map((token: any, index) => {
      let rule = rules.find(
        (rule: Rule) => rule.rulenumber.toString() === token
      );
      if (rule === null || rule === undefined) {
        finalExpression += token;
        index < tokens.length
          ? (finalExpression += " ")
          : (finalExpression += "");
      } else {
        finalExpression += rule.rulename;
        index < tokens.length
          ? (finalExpression += " ")
          : (finalExpression += "");
      }
    });
    return `(${finalExpression.trim()})`;
  }
  generateFinalRuleExpForMultipleAndOr(finalNumberRuleExp: string, rules: any) {
    let finalExpression = "";
    const regexGroup = /\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)/gi;
    const regexOperator = /\)\s*(AND|OR)\s*\(/gi;
    const regexToCheckForAndOr = /\(\s*[^()]*\b(AND|OR)\b[^()]*\s*\)/i;

    // Extract groups and operators
    const groups = finalNumberRuleExp.match(regexGroup) || [];
    const operators = [...finalNumberRuleExp.matchAll(regexOperator)].map(
      (match) => match[1]
    );

    groups.map((group: any, index) => {
      if(!regexToCheckForAndOr.test(group)){
        finalExpression += this.generateFinalRuleExpForSingleRule(group, rules);
      }
      else{
        finalExpression += this.generateFinalRuleExpForAndOrRule(group, rules);
      }
      finalExpression += " ";
      if (index + 1 < groups.length) {
        finalExpression += operators[index];
      }
      finalExpression += " ";
    });
    return finalExpression.trim();
  }
  //#endregion

  //#region This is responsible for converting the rule expression with rule names into rule expression with rule numbers
  convertTheNamedRuleExpToNumberRuleExp(
    finalNameRuleExp: string,
    rules: any
  ) {
    let finalExpression;
    const regexSingleRule = /^\(\s*[a-zA-Z0-9_]+(?:\s+(?!AND|OR\b)[a-zA-Z0-9_]+)*\s*\)$/i;
    const regexAndOrRule =  /^\(\s*[a-zA-Z0-9_ ]+(\s+(AND|OR)\s+[a-zA-Z0-9_ ]+)+\s*\)$/i;
    const regexMultipleAndOr = /^\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)\s*(AND|OR)\s*\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)(\s*(AND|OR)\s*\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\))*$/i;
    if (regexSingleRule.test(finalNameRuleExp.trim())) {
      finalExpression = this.generateNumberedRuleExpForSingleRule(
        finalNameRuleExp,
        rules
      );
    } else if (regexAndOrRule.test(finalNameRuleExp.trim())) {
      finalExpression = this.generateNumberedRuleExpForAndOrRule(
        finalNameRuleExp,
        rules
      );
    } else if (regexMultipleAndOr.test(finalNameRuleExp.trim())) {
      finalExpression = this.generateNumberedRuleExpForForMultipleAndOr(
        finalNameRuleExp,
        rules
      );
    }
    return finalExpression;
  }

  generateNumberedRuleExpForSingleRule(finalNameRuleExp: string, rules: any) {
    const ruleName = finalNameRuleExp.replace(/[()]/g, "").trim();
    let finalExpression = "";
    rules.map((rule: Rule) => {
      if (rule.rulename.toString() === ruleName) {
        finalExpression = rule.rulenumber.toString();
      }
    });
    return `(${finalExpression.trim()})`
  }
  generateNumberedRuleExpForAndOrRule(finalNameRuleExp: string, rules: any) {
    let finalExpression = "";
    // Remove outer parentheses and trim spaces
    const innerExpression = finalNameRuleExp.trim().slice(1, -1);
    // Split based on AND or OR while preserving operators
    const tokens = innerExpression.split(/\s+(AND|OR)\s+/i);

    tokens.map((token: any, index) => {
      let rule = rules.find(
        (rule: Rule) => rule.rulename.toString() === token
      );
      if (rule === null || rule === undefined) {
        finalExpression += token;
        index < tokens.length
          ? (finalExpression += " ")
          : (finalExpression += "");
      } else {
        finalExpression += rule.rulenumber;
        index < tokens.length
          ? (finalExpression += " ")
          : (finalExpression += "");
      }
    });
    return `(${finalExpression.trim()})`;
  }
  generateNumberedRuleExpForForMultipleAndOr(finalNameRuleExp: string, rules: any) {
    let finalExpression = "";
    const regexGroup =
      /\(\s*[a-zA-Z0-9_ ]+(\s*(AND|OR)\s*[a-zA-Z0-9_ ]+)?\s*\)/gi;
    const regexOperator = /\)\s*(AND|OR)\s*\(/gi;
    const regexToCheckForAndOr = /\(\s*[^()]*\b(AND|OR)\b[^()]*\s*\)/i;
    // Extract groups and operators
    const groups = finalNameRuleExp.match(regexGroup) || [];
    const operators = [...finalNameRuleExp.matchAll(regexOperator)].map(
      (match) => match[1]
    );

    groups.map((group: any, index) => {
      if(!regexToCheckForAndOr.test(group)){
        finalExpression += this.generateNumberedRuleExpForSingleRule(group, rules);
      }
      else{
        finalExpression += this.generateNumberedRuleExpForAndOrRule(group, rules);
      }      
      finalExpression += " ";
      if (index + 1 < groups.length) {
        finalExpression += operators[index];
      }
      finalExpression += " ";
    });
    return finalExpression.trim();
  }
  //#endregion
}